document.addEventListener('DOMContentLoaded', function () {
  const CFG = {
    fields: {
      precioVenta: 'precio_venta',
      precioVentaRecibido: 'precio_venta_recibido',
      importe: 'hidden_impvehic',
      antiguedad: 'hidden_antiguedad',
      devaluacion: 'hidden_devaluacion',
      cociente: 'hidden_cociente_devaluacion',
      baseImponible: 'hidden_base_imponible',
      cilindrada: 'hidden_cilindrada',
      potenciaFiscal: 'hidden_potencia_fiscal',
      ccaaInput: 'ccaa_comprador',
      ccaa: 'hidden_ccaa_comprador',
      tipoImpositivo: 'hidden_tipo_impositivo',
      cuotaItp: 'hidden_cuota_itp',
    },
    endpoints: {
      depreciacionLookup: '/wp-json/catalogos/v1/depreciacion/lookup',
      reglaFiscal: '/wp-json/catalogos/v1/itp/resolver-regla',
    },
    tipoBienDepreciacion: 'VE',
    outputSelectors: {
      ccaa: '[data-itp-ccaa]',
      devaluacion: '[data-itp-devaluacion]',
      baseImponible: '[data-itp-base-imponible]',
      tipoImpositivo: '[data-itp-tipo-impositivo]',
      cuota: '[data-itp-cuota]',
      mensaje: '[data-itp-mensaje]',
    },
  };

  let calcToken = 0;

  // Spinner overlay inyectado una sola vez dentro de .calculos-totales
  var spinnerOverlay = null;
  function getSpinnerOverlay() {
    if (!spinnerOverlay) {
      var container = document.querySelector('.calculos-totales');
      if (container) {
        spinnerOverlay = document.createElement('div');
        spinnerOverlay.className = 'itp-spinner-overlay';
        spinnerOverlay.innerHTML = '<div class="itp-spinner"></div>';
        container.appendChild(spinnerOverlay);
      }
    }
    return spinnerOverlay;
  }

  function showSpinner() {
    var el = getSpinnerOverlay();
    if (el) el.classList.add('visible');
  }

  function hideSpinner() {
    var el = getSpinnerOverlay();
    if (el) el.classList.remove('visible');
  }

  // Oculta el spinner solo cuando base_imponible_enviado tiene un valor calculado.
  // Comprueba cada 150 ms; desiste tras ~3 s (20 intentos) o si arranca un nuevo cálculo.
  function hideSpinnerWhenReady(token) {
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      if (token !== calcToken) {
        // Nuevo cálculo en marcha; este intervalo ya no debe actuar
        clearInterval(interval);
        return;
      }
      var el = document.querySelector('[name="base_imponible_enviado"]');
      var val = el ? String(el.value || '').trim() : '';
      var listo = val !== '' && val !== '0';
      if (listo || attempts >= 20) {
        clearInterval(interval);
        hideSpinner();
      }
    }, 150);
  }

  function getField(name) {
    return document.querySelector('[name="' + name + '"]');
  }

  function getSelect(name) {
    return document.querySelector('select[name="' + name + '"]');
  }

  function dispatchNativeEvents(el) {
    if (!el) return;
    try {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
      const evtInput = document.createEvent('Event');
      evtInput.initEvent('input', true, true);
      el.dispatchEvent(evtInput);

      const evtChange = document.createEvent('Event');
      evtChange.initEvent('change', true, true);
      el.dispatchEvent(evtChange);
    }
  }

  function setFieldValue(name, value) {
    const el = getField(name);
    if (!el) {
      return;
    }

    const strValue = value === null || value === undefined ? '' : String(value);
    el.value = strValue;

    if (el.jfbSync) {
      el.jfbSync.value.current = strValue;
    }

    dispatchNativeEvents(el);
  }

  function getFieldValue(name) {
    const el = getField(name);
    return el ? String(el.value || '').trim() : '';
  }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function parseNumber(value) {
    if (value === null || value === undefined) return null;
    let s = String(value).trim();
    if (!s) return null;

    s = s.replace(/\s+/g, '');
    const hasComma = s.indexOf(',') !== -1;
    const hasDot = s.indexOf('.') !== -1;

    if (hasComma && hasDot) {
      if (s.lastIndexOf(',') > s.lastIndexOf('.')) {
        s = s.replace(/\./g, '').replace(',', '.');
      } else {
        s = s.replace(/,/g, '');
      }
    } else if (hasComma) {
      s = s.replace(',', '.');
    }

    s = s.replace(/[^\d.-]/g, '');
    if (!s || s === '-' || s === '.') return null;

    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }

  function round2(n) {
    return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
  }

  function formatES(num) {
    var parts = num.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts[0] + ',' + parts[1];
  }

  function formatMoney(n) {
    const num = parseNumber(n);
    if (num === null) return '';
    return formatES(num) + ' €';
  }

  function formatPercent(n) {
    const num = parseNumber(n);
    if (num === null) return '';
    return formatES(num) + ' %';
  }

  function setText(selector, value) {
    const el = document.querySelector(selector);
    if (el) el.textContent = value == null ? '' : String(value);
  }

  function renderSummary(summary) {
    setText(CFG.outputSelectors.ccaa, summary.ccaa || '');
    setText(
      CFG.outputSelectors.devaluacion,
      summary.devaluacion != null ? formatPercent(summary.devaluacion) : ''
    );
    setText(
      CFG.outputSelectors.baseImponible,
      summary.baseImponible != null ? formatMoney(summary.baseImponible) : ''
    );
    setText(
      CFG.outputSelectors.tipoImpositivo,
      summary.tipoImpositivo != null ? formatPercent(summary.tipoImpositivo) : ''
    );
    setText(
      CFG.outputSelectors.cuota,
      summary.cuota != null ? formatMoney(summary.cuota) : ''
    );
    setText(CFG.outputSelectors.mensaje, summary.mensaje || '');
  }

  function clearFiscalFields(message) {
    setFieldValue(CFG.fields.devaluacion, '');
    setFieldValue(CFG.fields.cociente, '');
    setFieldValue(CFG.fields.baseImponible, '');
    setFieldValue(CFG.fields.ccaa, '');
    setFieldValue(CFG.fields.tipoImpositivo, '');
    setFieldValue(CFG.fields.cuotaItp, '');

    renderSummary({
      ccaa: '',
      devaluacion: null,
      baseImponible: null,
      tipoImpositivo: null,
      cuota: null,
      mensaje: message || '',
    });
  }

  function extractDepreciacion(data) {
    const pct = parseNumber(
      data &&
        (data.porcentaje_depreciacion ||
          data.porcentaje_depreciaci_n ||
          data.porcentaje ||
          data.depreciacion)
    );

    let factor = parseNumber(
      data && (data.cociente || data.cociente_devaluacion || data.factor)
    );

    if (factor === null && pct !== null) {
      factor = pct > 1 ? pct / 100 : pct;
    }

    if (pct === null && factor !== null) {
      return {
        porcentaje: round2(factor * 100),
        factor: factor,
      };
    }

    if (pct !== null && factor !== null) {
      return {
        porcentaje: pct > 1 ? pct : round2(pct * 100),
        factor: factor,
      };
    }

    return null;
  }

  function extractRegla(data) {
    const tipo = parseNumber(
      data &&
        (data.tipo_impositivo ||
          data.tax_rate ||
          data.tipo ||
          data.rate ||
          data.porcentaje)
    );

    const ccaa =
      data &&
      (data.ccaa ||
        data.ccaa_code ||
        data.comunidad ||
        data.comunidad_autonoma ||
        data.nombre_ccaa ||
        '');

    const mensaje = data && (data.message || data.mensaje || '');

    return {
      ccaa: ccaa || '',
      tipo: tipo,
      mensaje: mensaje || '',
    };
  }

  var _recalcTimer = null;
  function recalculateITP() {
    clearTimeout(_recalcTimer);
    _recalcTimer = setTimeout(_doRecalculateITP, 20);
  }

  function _doRecalculateITP() {
    const currentToken = ++calcToken;

    // Advanced Choice de JFB: querySelector devuelve SIEMPRE el primer radio (veh_coche),
    // no el seleccionado. Hay que buscar el que tiene :checked o el <li> con is-checked.
    var vehiculoChecked = document.querySelector('[name="elegir_vehiculo"]:checked')
      || document.querySelector('.jet-form-builder-choice--item.is-checked [name="elegir_vehiculo"]');
    var vehiculoValue = vehiculoChecked ? vehiculoChecked.value : '';
    if (!vehiculoValue) {
      clearFiscalFields('');
      return;
    }

    const cbNoListado = document.querySelector('[name="checkbox_veh_no_listado"]');
    const esNoListado = !!(cbNoListado && cbNoListado.checked);

    const importe = parseNumber(getFieldValue(CFG.fields.importe));
    const antiguedad = parseNumber(getFieldValue(CFG.fields.antiguedad));
    const potenciaFiscal = parseNumber(getFieldValue(CFG.fields.potenciaFiscal));
    const cilindrada = parseNumber(getFieldValue(CFG.fields.cilindrada));
    const precioVentaCatalogo  = parseNumber(getFieldValue(CFG.fields.precioVenta));
    const precioVentaRecibido  = parseNumber(getFieldValue(CFG.fields.precioVentaRecibido));
    const precioVenta = (precioVentaCatalogo !== null && precioVentaRecibido !== null)
      ? Math.max(precioVentaCatalogo, precioVentaRecibido)
      : (precioVentaRecibido !== null ? precioVentaRecibido : precioVentaCatalogo);
    const ccaaComprador = getFieldValue(CFG.fields.ccaaInput);

    if (!esNoListado && importe === null) {
      clearFiscalFields('Falta seleccionar un vehículo válido.');
      return;
    }

    if (antiguedad === null) {
      clearFiscalFields('Falta la antigüedad del vehículo.');
      return;
    }

    // Vehículo no listado: sin importe de catálogo → saltar depreciación,
    // ir directamente a resolver el tipo impositivo con los datos manuales.
    if (esNoListado) {
      setFieldValue(CFG.fields.devaluacion, '');
      setFieldValue(CFG.fields.cociente, '');
      setFieldValue(CFG.fields.baseImponible, '');

      if (!ccaaComprador || ccaaComprador === '0') {
        renderSummary({
          ccaa: '', devaluacion: null, baseImponible: null,
          tipoImpositivo: null, cuota: null,
          mensaje: 'Llámenos para obtener este presupuesto',
        });
        return;
      }

      const reglaUrlNL = new URL(CFG.endpoints.reglaFiscal, window.location.origin);
      reglaUrlNL.searchParams.set('ccaa_comprador', ccaaComprador);
      if (potenciaFiscal !== null) reglaUrlNL.searchParams.set('potencia_fiscal', potenciaFiscal);
      if (cilindrada !== null) reglaUrlNL.searchParams.set('cilindrada', cilindrada);
      if (antiguedad !== null) reglaUrlNL.searchParams.set('antiguedad', antiguedad);

      showSpinner();
      fetchJSON(reglaUrlNL.toString())
        .then(function (reglaData) {
          hideSpinner();
          if (currentToken !== calcToken) return;
          const regla = extractRegla(reglaData);
          if (regla.tipo === null) {
            setFieldValue(CFG.fields.ccaa, regla.ccaa || '');
            setFieldValue(CFG.fields.tipoImpositivo, '');
            setFieldValue(CFG.fields.cuotaItp, '');
            return;
          }
          const tipoImpositivoPct = regla.tipo > 1 ? regla.tipo : round2(regla.tipo * 100);
          setFieldValue(CFG.fields.ccaa, regla.ccaa || '');
          setFieldValue(CFG.fields.tipoImpositivo, tipoImpositivoPct);
          setFieldValue(CFG.fields.cuotaItp, '');
          renderSummary({
            ccaa: regla.ccaa || '',
            devaluacion: null,
            baseImponible: null,
            tipoImpositivo: tipoImpositivoPct,
            cuota: null,
            mensaje: regla.mensaje || '',
          });
        })
        .catch(function (err) {
          hideSpinner();
          if (currentToken !== calcToken) return;
          console.error('Error resolviendo regla fiscal (no listado):', err);
          setFieldValue(CFG.fields.ccaa, '');
          setFieldValue(CFG.fields.tipoImpositivo, '');
          setFieldValue(CFG.fields.cuotaItp, '');
          renderSummary({
            ccaa: '', devaluacion: null, baseImponible: null,
            tipoImpositivo: null, cuota: null,
            mensaje: 'No se ha podido resolver la regla fiscal.',
          });
        });
      return;
    }

    const depUrl = new URL(CFG.endpoints.depreciacionLookup, window.location.origin);
    depUrl.searchParams.set('tipo_bien', vehiculoValue === 'veh_moto' ? 'MO' : CFG.tipoBienDepreciacion);
    depUrl.searchParams.set('antiguedad', antiguedad);

    var reglaUrl = null;
    if (ccaaComprador && ccaaComprador !== '0') {
      reglaUrl = new URL(CFG.endpoints.reglaFiscal, window.location.origin);
      reglaUrl.searchParams.set('ccaa_comprador', ccaaComprador);
      if (potenciaFiscal !== null) reglaUrl.searchParams.set('potencia_fiscal', potenciaFiscal);
      if (cilindrada !== null) reglaUrl.searchParams.set('cilindrada', cilindrada);
    }

    showSpinner();
    Promise.all([
      fetchJSON(depUrl.toString()),
      reglaUrl ? fetchJSON(reglaUrl.toString()) : Promise.resolve(null),
    ])
      .then(function (results) {
        hideSpinnerWhenReady(currentToken);
        if (currentToken !== calcToken) return;

        var depData = results[0];
        var reglaData = results[1];

        const dep = extractDepreciacion(depData);
        if (!dep || dep.factor === null) {
          throw new Error('No se ha podido interpretar la depreciación.');
        }

        const valorDepreciado = round2(importe * dep.factor);
        const baseImponibleInicial =
          precioVenta !== null
            ? round2(Math.max(precioVenta, valorDepreciado))
            : valorDepreciado;

        setFieldValue(CFG.fields.devaluacion, dep.porcentaje);
        setFieldValue(CFG.fields.cociente, dep.factor);
        setFieldValue(CFG.fields.baseImponible, baseImponibleInicial);

        if (!reglaData) {
          setFieldValue(CFG.fields.tipoImpositivo, '');
          setFieldValue(CFG.fields.cuotaItp, '');
          renderSummary({
            ccaa: '',
            devaluacion: dep.porcentaje,
            baseImponible: baseImponibleInicial,
            tipoImpositivo: null,
            cuota: null,
            mensaje: 'Llámenos para obtener este presupuesto',
          });
          return;
        }

        const regla = extractRegla(reglaData);

        if (regla.tipo === null) {
          setFieldValue(CFG.fields.ccaa, regla.ccaa || '');
          setFieldValue(CFG.fields.tipoImpositivo, '');
          setFieldValue(CFG.fields.cuotaItp, '');
          return;
        }

        const tipoImpositivoPct =
          regla.tipo > 1 ? regla.tipo : round2(regla.tipo * 100);

        const tipoImpositivoFactor =
          regla.tipo > 1 ? regla.tipo / 100 : regla.tipo;

        const cuota = round2(baseImponibleInicial * tipoImpositivoFactor);

        setFieldValue(CFG.fields.ccaa, regla.ccaa || '');
        setFieldValue(CFG.fields.tipoImpositivo, tipoImpositivoPct);
        setFieldValue(CFG.fields.cuotaItp, cuota);

        renderSummary({
          ccaa: regla.ccaa || '',
          devaluacion: dep.porcentaje,
          baseImponible: baseImponibleInicial,
          tipoImpositivo: tipoImpositivoPct,
          cuota: cuota,
          mensaje: regla.mensaje || '',
        });
      })
      .catch(function (err) {
        hideSpinner();
        if (currentToken !== calcToken) return;
        console.error('Error calculando ITP:', err);
        clearFiscalFields('No se ha podido calcular el ITP del vehículo.');
      });
  }

  const watchedFields = [
    CFG.fields.importe,
    CFG.fields.antiguedad,
    CFG.fields.potenciaFiscal,
    CFG.fields.cilindrada,
    CFG.fields.precioVenta,
    CFG.fields.ccaaInput,
  ];

  watchedFields.forEach(function (name) {
    const el = getField(name) || getSelect(name);
    if (!el) return;
    el.addEventListener('input', recalculateITP);
    el.addEventListener('change', recalculateITP);
  });

  window.addEventListener('itp:vehiculo-updated', recalculateITP);

  // Formatea el campo de precio al perder el foco sin añadir '€' (los inputs de JFB
  // no pueden contener el símbolo o sus cálculos internos devuelven NaN).
  function bindPriceInput(el) {
    if (!el || el._priceFmt) return;
    el._priceFmt = true;

    var prevNum = parseNumber(el.value);
    var isNumType = el.type === 'number';

    el.addEventListener('change', function () {
      var cur = parseNumber(el.value);
      if (cur === prevNum) return;
      prevNum = cur;
      recalculateITP();
    });

    el.addEventListener('blur', function () {
      var n = parseNumber(el.value);
      if (n === null || isNaN(n)) return;
      if (isNumType) el.type = 'text';
      el.value = formatES(n);
      if (el.jfbSync) el.jfbSync.value.current = el.value;
    });

    el.addEventListener('focus', function () {
      var n = parseNumber(el.value);
      if (n === null || isNaN(n)) return;
      var raw = String(Math.round(n * 100) / 100);
      if (isNumType) {
        el.type = 'number';
      } else {
        raw = raw.replace('.', ',');
      }
      el.value = raw;
      if (el.jfbSync) el.jfbSync.value.current = raw;
    });
  }

  bindPriceInput(getField(CFG.fields.precioVentaRecibido));

  function calcAntigüedad(dateStr) {
    if (!dateStr) return null;
    const reg = new Date(dateStr);
    if (isNaN(reg.getTime())) return null;
    const years = (Date.now() - reg.getTime()) / (1000 * 60 * 60 * 24 * 365.25);
    return years < 0 ? 0 : Math.round(years * 100) / 100;
  }

  const fechaMatriculacion = getField('fecha_primera_matriculacion');
  if (fechaMatriculacion) {
    fechaMatriculacion.addEventListener('change', function () {
      const antiguedad = calcAntigüedad(fechaMatriculacion.value);
      setFieldValue(CFG.fields.antiguedad, antiguedad !== null ? antiguedad : '');
    });

    fechaMatriculacion.addEventListener('input', function () {
      const antiguedad = calcAntigüedad(fechaMatriculacion.value);
      setFieldValue(CFG.fields.antiguedad, antiguedad !== null ? antiguedad : '');
    });
  }

  recalculateITP();

  // ── Ocultar "Continuar Trámite" si la CCAA seleccionada es País Vasco (PV) ──
  function updateBotonContinuar() {
    var ccaaVal = getFieldValue(CFG.fields.ccaaInput);
    var btn = document.querySelector('.jet-form-builder__next-page, [data-jfb-action="go-next"]');
    if (!btn) return;

    if (ccaaVal === 'PV') {
      btn.style.setProperty('display', 'none', 'important');
    } else {
      btn.style.removeProperty('display');
    }
  }

  var elCcaa = getField(CFG.fields.ccaaInput) || getSelect(CFG.fields.ccaaInput);
  if (elCcaa) {
    elCcaa.addEventListener('change', updateBotonContinuar);
    elCcaa.addEventListener('input', updateBotonContinuar);
  }

  updateBotonContinuar();
});


// WEBPACK FOOTER //
// ./scripts/formularios-itp/catalogos-jetform.js